import { Box, Container, Divider } from "@mui/material";
import palette from "../theme/palette";

export default function Footer() {
  return (
    <Box
      sx={{
        mt: 3,
        pb: 1,
        bgcolor: palette.background.neutral,
      }}
    >
      <Divider />
      <Container>
        <Box
          sx={{
            display: 'flex',
            fontSize: '0.857em',
            color: palette.text.primary,
            '& >*': {
              mr: 1,
              ':hover': {
                textDecoration: 'underline',
                cursor: 'pointer'
              }
            }
          }}
        >
          <Box
            onClick={() => window.open('https://avidid.com/terms-conditions', '_blank')}
          >
            Terms and conditions
          </Box>
          <Box
            onClick={() => window.open('https://avidid.com/privacy-policy', '_blank')}
          >
            Privacy Policy
          </Box>
        </Box>
        <Box
          sx={{
            fontSize: '0.857em',
            color: palette.text.secondary
          }}
        >
          Copyright © 2015-{`${new Date().getFullYear()}`} Avid Identification Systems, Inc. All rights reserved.
        </Box>
      </Container>
    </Box>
  )
}